import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var MediaSVGError = /*#__PURE__*/function (_Error) {
  function MediaSVGError(primaryReason, secondaryError) {
    var _this;
    _classCallCheck(this, MediaSVGError);
    _this = _callSuper(this, MediaSVGError, [primaryReason]);

    // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
    _this.primaryReason = primaryReason;
    _this.secondaryError = secondaryError;
    Object.setPrototypeOf(_this, (this instanceof MediaSVGError ? this.constructor : void 0).prototype);

    // https://v8.dev/docs/stack-trace-api
    if ('captureStackTrace' in Error) {
      Error.captureStackTrace(_this, this instanceof MediaSVGError ? this.constructor : void 0);
    }
    return _this;
  }
  _inherits(MediaSVGError, _Error);
  return _createClass(MediaSVGError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var createUnexpectedErrorCallback = function createUnexpectedErrorCallback(onError) {
  return function (e) {
    onError === null || onError === void 0 || onError(new MediaSVGError('unexpected', e));
  };
};